import { autoinject, observable } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { DateValue } from 'app/shared/lib/date-time';
import { guid } from 'app/shared/lib/guid';

@autoinject()
export class DemoEssDateRangePage extends ComponentBase {

    protected autocompleteOptions: Array<string> = ['off', 'on'];
    protected id: guid = guid();

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);
        this.logger.source = this;
    }

    ////****************** Example 1 ********************************************////

    ////****************** Example 2 ********************************************////
    protected ex2MaxDate?: string | null = null;
    protected ex2MinDate?: string | null = null;

    @observable({ changeHandler: 'calculateMinDate' })
    protected ex2MinDateOffset?: number | null = null;
    @observable({ changeHandler: 'calculateMaxDate' })
    protected ex2MaxDateOffset?: number | null = null;

    protected calculateMinDate(...args: any[]): void {
        if(this.ex2MinDateOffset) {
            let dateVal = new DateValue(this.env.today).add(this.ex2MinDateOffset, 'days');
            this.ex2MinDate = dateVal.toString();
        }
        else {
            this.ex2MinDate = null;
        }
    }

    protected calculateMaxDate(...args: any[]): void {
        if(this.ex2MaxDateOffset) {
            let dateVal = new DateValue(this.env.today).add(this.ex2MaxDateOffset, 'days');
            this.ex2MaxDate = dateVal.toString();
        }
        else {
            this.ex2MaxDate = null;
        }
    }

    ////****************** Example 3 ********************************************////
    protected ex3Label: string | null = 'Date Range';
    protected ex3RequiredValidatorLabel: string | null = 'Another Date Range';


}
